// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GeA3","colMin":"styles_colMin__qq3W-"};